import styled from 'styled-components';

export const Title = styled.div`
  text-align: center;
  margin-bottom: 18px;
`;
